export const DsHelperTextDefaultProps = {
    helperText: ''
};
